import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_manage/manage/admin/dashboard/email-settings')({
  beforeLoad: () => {
    throw redirect({
      to: '/manage/admin/settings',
      search: { tab: 'email' },
      replace: true,
    })
  },
})
